import React, { Component } from 'react';
// redux
import { connect } from 'react-redux';
import { getFavorites, getResources } from '../../redux/reducers/resources';
// components
import { NavLink } from 'react-router-dom';
import Preloader from '../../components/Preloader/Preloader';
import PageWrapper from '../../components/PageWrapper/PageWrapper';
import ResourcesGrid from './components/ResourcesGrid';
// styles
import styles from './Resources.mod.css';

class Resources extends Component {
  componentDidMount() {
    const {
      match: {
        params: { type }
      }
    } = this.props;
    this.getResources(type);
  }

  componentWillReceiveProps(nextProps) {
    const {
      match: {
        params: { type }
      }
    } = nextProps;
    if (this.props.match.params.type !== type) {
      this.getResources(type);
    }
  }

  getResources = type => {
    const { getFavorites, getResources } = this.props;
    const resourceType = {
      recovery: 'document_resource',
      worksheets: 'link_resource',
      saved: 'additional_resource',
      articles: 'step_resource'
    };
    const resource_type = resourceType[type];
    resource_type
      ? getResources({
          filter: {
            resource_type
          }
        })
      : getFavorites();
  };

  render() {
    const {
      isLoading,
      match: {
        params: { type }
      }
    } = this.props;

    return (
      <PageWrapper>
        <div className={styles.wrapper}>
          <div className={styles.leftColumn}>
            <div className={styles.menu}>
              <NavLink to="/resources" exact>
                My favorites
              </NavLink>
              <NavLink to="/resources/recovery">Videos</NavLink>
              <NavLink to="/resources/saved">
                Articles, infographics and additional research
              </NavLink>
              <NavLink to="/resources/worksheets">Other websites</NavLink>
              <NavLink to="/resources/articles">
                Saved content from the modules
              </NavLink>
            </div>
          </div>

          <div className={styles.rightColumn}>
            <Preloader className={styles.preloader} isActive={isLoading} />
            <ResourcesGrid type={type} />
          </div>
        </div>
      </PageWrapper>
    );
  }
}

export default connect(
  state => ({
    isLoading: state.resources.isLoading
  }),
  { getFavorites, getResources }
)(Resources);



// WEBPACK FOOTER //
// ./src/containers/Resources/Resources.jsx